import { colorsPalettes } from "@similarweb/styles";
import { LegendWithOneLineCheckboxFlexWithSubtitle } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { Legends } from "app/components/React/Legends/Legends";
import type { ILegendItem, ILegendItems } from "app/components/React/Legends/legendsTypes";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

interface KeywordGroupsScatterPlotLegendsProps {
    legendItems: ILegendItems;
    onToggle: (legendId: ILegendItem) => void;
}

export const KeywordGroupsScatterPlotLegends = ({ legendItems, onToggle }: KeywordGroupsScatterPlotLegendsProps) => {
    const t = useTranslation();

    return (
        <Flex
            flexDirection="column"
            gap="12px"
            width="248px"
        >
            <Flex justifyContent="space-between">
                <Text
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[400]}
                >
                    {t("demand_analysis.common.keyword_list")}
                </Text>
                <Text
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[400]}
                >
                    {t("common.volume")}
                </Text>
            </Flex>
            <Legends
                gridDirection="column"
                legendItems={legendItems}
                legendComponent={LegendWithOneLineCheckboxFlexWithSubtitle}
                toggleSeries={onToggle}
            />
        </Flex>
    );
};
